// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"9b19f982","977":"d71040fc"}[chunkId] + ".chunk.js";
};